import { ApolloLink, Observable } from "@apollo/client";
import { API_URL } from "../constants";

const TIMEOUT = 15000;

function shouldSkipOperation(operation) {
  try {
    const opDef = operation?.query?.definitions?.find(
      (def) => def.kind === "OperationDefinition"
    );
    let opName = opDef?.name?.value || "";
    if (!opName && operation?.query?.loc?.source?.body) {
      const queryText = operation.query.loc.source.body;
      const match = queryText.match(/\b(query|mutation|subscription)\s+([a-zA-Z0-9_]+)/i);
      if (match && match[2]) opName = match[2];
    }
    if (!opName && opDef?.selectionSet?.selections?.length) {
      const firstField = opDef.selectionSet.selections[0];
      opName = firstField?.name?.value || "";
    }
    opName = (opName || "").trim().toLowerCase();
    const skipNames = ["get_user_list", "get_roles_with_users"];
    return skipNames.includes(opName);
  } catch (err) {
    console.error("Error checking operation name:", err);
    return false;
  }
}



export const httpLink = new ApolloLink((operation) => {
  return new Observable((observer) => {
    let {
      headers = {},
      encryptedBody,
      bypassEncryption,
      uri = `${API_URL}phloan/api/v1`,
      targetPath
    } = operation.getContext();

    /* 🌐 DYNAMIC API ROUTING */
      console.log(window.location.pathname,"window.location.pathname<<")
    if (!targetPath) {
      if (window.location.pathname.includes('/inventory-funding')) {
        targetPath = 'dif-ph';
      } else if (window.location.pathname.includes('/refinance')) {
        targetPath = 'ph-refinance/api';
      } else {
        targetPath = 'phloan';
      }
    }

    let finalUri = uri;
    if (targetPath === "dif-ph") {
      finalUri = `${API_URL}dif-ph/api/v1`;
    }
    if (targetPath === "ph-refinance/api") {
      finalUri = `${API_URL}ph-refinance/api`;
    }

    const body = !bypassEncryption && encryptedBody
      ? JSON.stringify(encryptedBody)
      : JSON.stringify({
          query: operation.query.loc.source.body,
          variables: operation.variables,
          operationName: operation.operationName
        });

      const skipEncryption = shouldSkipOperation(operation);

      if (skipEncryption) {
        finalUri = `${API_URL}phloan/api/v1`;
        const opDef = operation?.query?.definitions?.find(
          (def) => def.kind === "OperationDefinition"
        );
        let opName =opDef?.name?.value || opDef?.selectionSet?.selections?.[0]?.name?.value ||"UnnamedOperation";

        console.log("Skipping encryption for:", opName);
      }


    const finalHeaders = {
      "Content-Type": "application/json",
      ...headers
    };

    if (bypassEncryption) {
      delete finalHeaders.is_encrypt_response;
    }

    const controller = new AbortController();
    const timer = setTimeout(() => {
      controller.abort();
      observer.error(new Error("Request timeout"));
    }, TIMEOUT);

    fetch(finalUri, {
      method: "POST",
      headers: finalHeaders,
      body,
      signal: controller.signal
    })
      .then(async (res) => {
        clearTimeout(timer);
        if (!res.ok) {
          throw {
            name: "ServerError",
            statusCode: res.status,
            message: res.statusText,
            result: await res.json().catch(() => null)
          };
        }
        return res.json();
      })
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((err) => {
        clearTimeout(timer);
        observer.error(err);
      });

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  });
});
